import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import optionalCalculator from './modules/optionalCalculator'
import constants from './modules/constants'
import orders from './modules/orders'
import users from './modules/users'
import externalLinks from '@/store/modules/externalLinks'
import messages from '@/store/modules/messages'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    query: window.location.search ? `/${window.location.search}` : '/',
    rulesDocUrl: `${window.location.origin}/docs/Regulamin_Serwisu_01.02.2024.pdf`,
    policyDocUrl: `https://app.gorodo.pl/api/polityka_prywatnosci/1132782112/zbudujplan.pl`,
  },
  mutations: {},
  actions: {},
  modules: {
    messages,
    user,
    optionalCalculator,
    constants,
    orders,
    users,
    externalLinks,
  },
})
